import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var PaymentMethodsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default PaymentMethodsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Refreshs/RefreshsReduxProps.ts
// module id = 61
// module chunks = 0